import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformServer } from '@angular/common';
import { Helper } from '@app/core/helper';
import { environment } from '@env/environment';

@Injectable({
    providedIn: 'root',
})
export class ScriptService {
    private map: any = {};

    constructor (
        @Inject(DOCUMENT)
        private d: Document,
        @Inject(PLATFORM_ID)
        private p: any,
    ) {}

    load(src: string): Promise<boolean> {
        if (isPlatformServer(this.p)) {
            return Promise.resolve(true);
        }
        return this.loadJs(Helper.applyCdn('/' + environment.assets.d + '/' + this.d.documentElement.lang + '/' + src) + '?v=' + environment.assets.v);
    }

    loadJs(src: string): Promise<boolean> {
        if (isPlatformServer(this.p)) {
            return Promise.resolve(true);
        }
        if (this.map[src]) {
            return this.map[src];
        }
        return this.map[src] = new Promise<boolean>(resolve => {
            const script = this.d.createElement('script');
            script.onload = () => resolve(true);
            script.src = src;
            this.d.head.append(script);
        });
    }

    style(src: string): Promise<HTMLLinkElement> {
        if (this.map[src]) {
            return this.map[src];
        }
        const styles: any = this.d.querySelectorAll('link[rel="stylesheet"][href]');
        for (let i = 0; i < styles.length; ++i) {
            if (styles[i]['href'].indexOf('/' + src + '?v=') >= 0) {
                return this.map[src] = Promise.resolve(styles[i] as HTMLLinkElement);
            }
        }
        return this.map[src] = new Promise<HTMLLinkElement>(resolve => {
            const elem = this.d.createElement('link');
            elem.onload = () => resolve(elem);
            elem.rel = 'stylesheet';
            elem.href = Helper.applyCdn('/' + environment.assets.d + '/' + src) + ('?v=' + environment.assets.v);
            this.d.head.appendChild(elem);
        });
    }
}
